module.exports = __webpack_public_path__ + "media/images/common/header_logo-ec85464c42735f19d7da4556373c3c1c.png";